import React, { FC, ReactNode } from 'react'

import Badge from '@/modules/components/Badge'
import Button from '@/modules/components/Button'
import Flex from '@/modules/components/Flex'
import Icon from '@/modules/components/Icon'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'

interface MobileMenuItemProps {
  title: string
  badgeTitle?: string
  content: ReactNode
  href?: string | null
  isExpanded?: boolean
  onClick?: (e) => void
}

const MobileMenuItem: FC<MobileMenuItemProps> = ({
  title,
  badgeTitle,
  content,
  href,
  isExpanded,
  onClick,
}) => {
  const IconComponent = isExpanded ? Icon.ChevronUp : Icon.ChevronDown

  const renderContent = () => (
    <>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Typography variant="subtitle2" color="primaryPaleWhite" leadingTrim>
            {title}
          </Typography>
          {badgeTitle && <Badge ml={1}>{badgeTitle}</Badge>}
        </Flex>
        {onClick && content && (
          <IconComponent fontSize="8px" color="primaryPaleWhite" />
        )}
      </Flex>
      {isExpanded && content}
    </>
  )

  if (href) {
    return <Link href={href}>{renderContent()}</Link>
  }

  return (
    <Button variant="plain" width="100%" onClick={onClick}>
      {renderContent()}
    </Button>
  )
}

export default MobileMenuItem
